let USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const formatCurrency = (value) => USDollar.format(value);
export const formatDate = (date) => new Date(typeof date === 'string' ? Number(date) : date).toLocaleDateString();
